import { Box, Grid, Typography, ImageListItem, ImageListItemBar, Checkbox } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import KenButton from '../../../../GlobalComponents/KenButton';
import { useStyles } from '../../style';
import { postBasicProfileSetting } from '../../../../Utils/apiService';
import { enqueueSnackbar } from 'notistack';
import { useState } from 'react';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { lg: '70vw', xl: '70vw', md: '70vw' },
  bgcolor: 'background.paper',
  border: '2px solid white',
  boxShadow: 24,
  borderRadius: 2,
  p: 2,
  overflowY: 'auto',
};

const PreferenceModel = (props: any) => {
  const { preferenceData, profileData, userData, setPreferStatus } = props;
  const classes = useStyles();
  const itemData = Object.entries(preferenceData).map(([title, img]) => ({ title, img }));
  console.log('preferenceData76567', preferenceData);

  const phrasesArray = profileData?.Preferences__c.split(';');
  const [checkedItems, setCheckedItems] = useState(itemData.map((item) => phrasesArray.includes(item.title)));
  const handleCheckboxChange = (index: any, title: any) => {
    setCheckedItems((prev) => {
      const newCheckedItems = [...prev];
      newCheckedItems[index] = !newCheckedItems[index];
      return newCheckedItems;
    });
  };

  const postProfileData = () => {
    const newTitles = checkedItems.map((isChecked, idx) => (isChecked ? itemData[idx].title : null)).filter(Boolean);
    const preferenceTitle = newTitles.join(';');

    const payload: any = {
      isProfilePicture: false,
      accountId: userData.applicantId,
      imageBlob: profileData?.Profile_Picture_URL__c,
      isBasicDetails: false,
      fullName: profileData?.Name,
      email: profileData?.Email,
      password: profileData?.Password1__c,
      phoneNumber: profileData?.Phone,
      isSocialMedia: false,
      linkedinURL: profileData?.LinkedIn_URL__c,
      facebookURL: profileData?.Facebook_URL__c,
      twitterURL: profileData?.Twitter_URL__c,
      isPermanentAddress: false,
      flatNo_pa: profileData?.House_flat_no_pa__c,
      street_pa: profileData?.Street_pa__c,
      suburb_pa: profileData?.Suburb_pa__c,
      city_pa: profileData?.City_pa__c,
      pinCode_pa: profileData?.Pincode_pa__c,
      isCurrentAddress: false,
      flatNo_ca: profileData?.House_flat_no_ca__c,
      street_ca: profileData?.Street_ca__c,
      suburb_ca: profileData?.Suburb_ca__c,
      city_ca: profileData?.City_ca__c,
      pinCode_ca: profileData?.Pincode_ca__c,
      isPreferences: true,
      Preferences: preferenceTitle,
    };
    postBasicProfileSetting(payload)
      .then((res) => {
        if (res?.success) {
          setPreferStatus(true);
          props.handleClose();

          enqueueSnackbar({
            message: 'Preference Saved Sucessfully',
            variant: 'success',
            autoHideDuration: 1000,
          });
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  };
  return (
    <div>
      <Box sx={style} className="scrollbar-cusgray">
        <Grid container spacing={2}>
          <Grid item xs={10}>
            <Typography sx={{ fontSize: '13px', fontWeight: 550 }}>Preferences</Typography>
            <Typography sx={{ fontSize: '10px', mt: 0.5 }}>Kindly select all applicable options that align with your requirements.</Typography>
          </Grid>
          <Grid item xs={2} style={{ display: 'flex', justifyContent: 'end', cursor: 'pointer' }}>
            <CloseIcon onClick={props.handleClose} sx={{ fontSize: '15px' }} />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          {itemData.map((item, index) => {
            console.log('item5645', item);

            return (
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <ImageListItem sx={{ borderRadius: 10 }}>
                  <img srcSet={`data:image/png;base64,${item.img}`} src={`data:image/png;base64,${item.img}`} alt={item.title} loading="lazy" style={{ borderRadius: '10px' }} />

                  <ImageListItemBar
                    title={
                      <Box
                        sx={{
                          width: '100%',
                          overflowX: 'auto',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            color: 'black',
                            display: 'inline-block',
                            fontSize: '12px',
                          }}
                        >
                          {item.title}
                        </Typography>
                      </Box>
                    }
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '10px',
                      margin: '10px',
                      height: '25px',
                    }}
                    actionIcon={
                      <IconButton sx={{ color: 'black' }} aria-label={`info about ${item.title}`}>
                        <Checkbox
                          checked={checkedItems[index]}
                          onChange={() => handleCheckboxChange(index, item.title)}
                          sx={{
                            width: '10px',
                            height: '10px',
                            '& .MuiSvgIcon-root': {
                              fontSize: '18px',
                            },
                            '&.Mui-checked': {
                              color: '#5981FF',
                            },
                          }}
                        />
                      </IconButton>
                    }
                    actionPosition="left"
                  />
                </ImageListItem>
              </Grid>
            );
          })}
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
          <KenButton variant="contained" className={classes.button} style={{ marginTop: 15, borderRadius: '8px', width: 150, boxShadow: 'none' }} onClick={postProfileData}>
            <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>Save Changes</Typography>
          </KenButton>
        </Box>
      </Box>
    </div>
  );
};

export default PreferenceModel;
